import { surveyLocalization } from "survey-core";

export var koreanStrings = {
  pagePrevText: "이전",
  pageNextText: "다음",
  completeText: "완료",
  previewText: "시사",
  editText: "편집하다",
  startSurveyText: "시작",
  otherItemText: "기타(설명)",
  noneItemText: "없음",
  selectAllItemText: "모두 선택",
  progressText: "페이지 {1} 중 {0}",
  panelDynamicProgressText: "{0} / {1} 기록",
  questionsProgressText: "{0} / {1} 개의 질문에 답변 함",
  emptySurvey: "설문지에 보여지는 페이지나 질문이 없습니다",
  completingSurvey: "설문 조사를 완료해 주셔서 감사합니다!",
  completingSurveyBefore: "기록에 따르면 이미 설문 조사를 마치셨습니다.",
  loadingSurvey: "설문조사가 로드중입니다...",
  placeholder: "선택하십시오...",
  value: "값",
  requiredError: "질문에 답하시오.",
  requiredErrorInPanel: "하나 이상의 질문에 답하십시오.",
  requiredInAllRowsError: "모든 행에 있는 질문에 답하십시오.",
  numericError: "값은 숫자여야 합니다.",
  textMinLength: "답변의 길이는 최소 {0}자여야 입니다.",
  textMaxLength: "답변의 길이는 {0}자를 초과 할 수 없습니다.",
  textMinMaxLength: "답변의 길이는 {0} - {1}자 사이여야 합니다.",
  minRowCountError: "최소 {0}개의 행을 채우십시오",
  minSelectError: "최소 {0}개의 변수를 선택하십시오.",
  maxSelectError: "최대 {0}개의 변수를 선택하십시오.",
  numericMinMax: "'{0}'은 {1}보다 크거나 같고 {2}보다 작거나 같아야합니다.",
  numericMin: "'{0}'은 {1}보다 크거나 같아야합니다.",
  numericMax: "'{0}'은 {1}보다 작거나 같아야합니다.",
  invalidEmail: "올바른 이메일 주소를 입력하십시오.",
  invalidExpression: "표현식: {0}은 '참'이어야 합니다.",
  urlRequestError: "'{0}'으로 잘못된 요청입니다. {1}",
  urlGetChoicesError: "비어있는 데이터를 요청했거나 잘못된 속성의 경로입니다.",
  exceedMaxSize: "파일 크기가 {0}을 초과 할 수 없습니다.",
  otherRequiredError: "다른 질문을 작성하십시오.",
  uploadingFile: "파일 업로드 중입니다. 잠시 후 다시 시도하십시오.",
  loadingFile: "로드 중...",
  chooseFile: "파일 선택...",
  noFileChosen: "선택된 파일이 없습니다",
  confirmDelete: "기록을 삭제하시겠습니까?",
  keyDuplicationError: " 이 값은 고유해야합니다.",
  addColumn: "열 추가",
  addRow: "행 추가",
  removeRow: "제거",
  addPanel: "새롭게 추가",
  removePanel: "제거",
  choices_Item: "항목",
  matrix_column: "열",
  matrix_row: "행",
  savingData: "결과가 서버에 저장 중입니다...",
  savingDataError: "오류가 발생하여 결과를 저장할 수 없습니다.",
  savingDataSuccess: "결과가 성공적으로 저장되었습니다!",
  saveAgainButton: "다시 시도하십시오",
  timerMin: "분",
  timerSec: "초",
  timerSpentAll: "현재 페이지에서 {0}을 소요해 총 {1}이 걸렸습니다.",
  timerSpentPage: "현재 페이지에서 {0]이 걸렸습니다",
  timerSpentSurvey: "총 {0}이 걸렸습니다.",
  timerLimitAll: "현재 페이지에서 {0}/{1}을 소요해 총 {2}/{3}이 걸렸습니다.",
  timerLimitPage: "현재 페이지에서 {0}/{1}이 걸렸습니다.",
  timerLimitSurvey: "총 {0}/{1}이 걸렸습니다.",
  cleanCaption: "닦기",
  clearCaption: "지우기",
  chooseFileCaption: "파일을 선택",
  removeFileCaption: "이 파일 제거",
  booleanCheckedLabel: "예",
  booleanUncheckedLabel: "아니",
  confirmRemoveFile: "{0} 파일을 제거 하시겠습니까?",
  confirmRemoveAllFiles: "모든 파일을 제거 하시겠습니까?",
  questionTitlePatternText: "질문 제목",
};

surveyLocalization.locales["ko"] = koreanStrings;
surveyLocalization.localeNames["ko"] = "한국어";
